import React from 'react'
import { Table, Tag, Space } from 'antd';
import MainViewWrapper from './MainViewWrapper'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Version',
    dataIndex: 'version',
    key: 'version',
  },
  {
    title: 'Progress',
    dataIndex: 'progress',
    key: 'progress',
  },
  {
    title: 'Tags',
    key: 'tags',
    dataIndex: 'tags',
    render: tags => (
      <>
        {tags.map(tag => {
          let color = tag.length > 5 ? 'geekblue' : 'green';
          if (tag === 'loser') {
            color = 'volcano';
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: 'Action',
    key: 'action',
    render: (text, record) => {
      console.log(record)
      const path = `/new-audit?id=${record.key}`
      return <Space size="middle">
              <Link to={path}>Edit</Link>
            </Space>
    }
  }
];

const data = [
  {
    key: '1',
    name: 'Bird Conservation',
    version: 1,
    progress: 'Pending review',
    tags: ['nice', 'haha'],
  },
  {
    key: '2',
    name: 'Bear Conservation',
    version: 3,
    progress: 'Finalized',
    tags: ['cute bear'],
  },
  {
    key: '3',
    name: 'Snake Study',
    version: 5,
    progress: 'Pending Approval',
    tags: ['snake!!!'],
  },
];

const AuditProgress = () => {
    return <MainViewWrapper>
                <Table columns={columns} dataSource={data} />
           </MainViewWrapper>
}

export default AuditProgress